(function(e) {
  
  
  
  
   var cookieName = "wishlistList";
  
   if (e(".collection_sidebar")) {
        //work only in collection page
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!t.isSidebarAjaxClick) {
                t.sidebarParams();
                var newurl = t.sidebarCreateUrl();
                t.sidebarGetContent(newurl);
                t.reActivateSidebar();
            }
            t.isSidebarAjaxClick = false;
        });
    }
  
    
  
      if (window.use_color_swatch) { 
  e('.swatch :radio').change(function() {
    var optionIndex = e(this).closest('.swatch').attr('data-option-index');
    var optionValue = e(this).val();
    e(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  }); 
  
  }
    
  
 // (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
        // See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options

        Shopify.optionsMap = {};

        Shopify.updateOptionsInSelector = function(selectorIndex) {

            switch (selectorIndex) {
                case 0:
                    var key = 'root';
                    var selector = e('.single-option-selector:eq(0)');
                    break;
                case 1:
                    var key = e('.single-option-selector:eq(0)').val();
                    var selector = e('.single-option-selector:eq(1)');
                    break;
                case 2:
                    var key = e('.single-option-selector:eq(0)').val();
                    key += ' / ' + e('.single-option-selector:eq(1)').val();
                    var selector = e('.single-option-selector:eq(2)');
            }

            var initialValue = selector.val();
            selector.empty();
            var availableOptions = Shopify.optionsMap[key];
            if (availableOptions && availableOptions.length) {
              for (var i = 0; i < availableOptions.length; i++) {
                  var option = availableOptions[i];
                  var newOption = e('<option></option>').val(option).html(option);
                  selector.append(newOption);
              }
              e('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
                  if (e.inArray(e(this).attr('data-value'), availableOptions) !== -1) {
                      e(this).removeClass('soldout').show().find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
                  } else {
                      e(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
                  }
              });
              if (e.inArray(initialValue, availableOptions) !== -1) {
                  selector.val(initialValue);
              }
              selector.trigger('change');
            }
        };

        Shopify.linkOptionSelectors = function(product) {
            // Building our mapping object.
            for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                if (variant.available) {
                    // Gathering values for the 1st drop-down.
                    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                    Shopify.optionsMap['root'].push(variant.option1);
                    Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
                    // Gathering values for the 2nd drop-down.
                    if (product.options.length > 1) {
                        var key = variant.option1;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option2);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                    // Gathering values for the 3rd drop-down.
                    if (product.options.length === 3) {
                        var key = variant.option1 + ' / ' + variant.option2;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option3);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                }
            }
            // Update options right away.
            Shopify.updateOptionsInSelector(0);
            if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
            if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
            // When there is an update in the first dropdown.
            e(".single-option-selector:eq(0)").change(function() {
                Shopify.updateOptionsInSelector(1);
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });
            // When there is an update in the second dropdown.
            e(".single-option-selector:eq(1)").change(function() {
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });

        };
    
  
    e(document).ready(function() {
        t.init()
    });
 
  e(window).resize(function() {
        t.initMobileMenu();        
        
    });
  
     e(document).on("click touchstart", function(n) {           
            var r = e(".quick-view");
            var i = e("#slidedown-cart");
            var s = e("#ToggleDown");
            var o = e("#email-modal .modal-window");
            var overlay = e("#vf-cart-overlay");
        
            // El sidebar se cierra sólo via su botón X o el overlay (gestionados en initDropDownCart)
            // Aquí sólo cerramos quick-view y email modal si el click fue fuera
            if (!r.is(n.target) && r.has(n.target).length === 0 && !o.is(n.target) && o.has(n.target).length === 0) {
                t.closeQuickViewPopup();
                t.closeEmailModalWindow();
            }
        })
    
    e(document).keyup(function(n) {
        if (n.keyCode == 27) {
            t.closeQuickViewPopup();
            t.closeDropdownCart();
            clearTimeout(t.KidsTimeout);
            if (e(".modal").is(":visible")) {
                e(".modal").fadeOut(500)
            }
        }
    });
    var t = {
        KidsTimeout: null,
        isSidebarAjaxClick: false,
        init: function() {    
            this.initQuickView();
            this.initAddToCart();
          	this.initThumbchange();
            this.initlightSlider();
            this.initModal();
            this.initProductAddToCart();
            this.initDropDownCart();
            this.initWishlist();           
            this.initMobileMenu();                   
            this.initProductMoreview();                                             
            this.initelevateZoom();            
            this.initShortcode();            
            this.initScrollTop();
            
            this.initHeaderSticky();
            
            this.initSidebar();
            this.initColorSwatchGrid();  
            this.initInfiniteScrolling();
            // initPrimeProduct no se llama aquí a propósito: las plantillas
            // product.servicios-prime / basico-especializado / sesiones ya
            // registran sus propios handlers. Evita doble binding.
        },
       initColorSwatchGrid: function() { 
          jQuery('.item-swatch li label').click(function(){                                   
            var newImage = jQuery(this).parent().find('.hidden img').attr('src');
           jQuery(this).parents('.item-row').find('.featured-image').attr({ src: newImage }); 
            return false;
          });
        },
      
      
       initHeaderSticky: function(){
       var w = window.innerWidth;
       if (w > 767) {          
         e(".header-sticky").sticky({topSpacing:0});
         var headerH = $('.header-sticky').height();
            e(document).bind('ready scroll', function() {
              var docScroll = $(document).scrollTop();
                if(docScroll >= headerH) {
                    if (!e('#header-landing').hasClass('header-animate')) {
                        e('#header-landing').addClass('header-animate').css({ top: '-155px' }).stop().animate({ top: 0 }, 500);
                    }
                } else {
                    e('#header-landing').removeClass('header-animate').removeAttr('style');
                }
            });
        }
     if (w < 967) {/* e('.desktop-megamenu').remove();*/}
       },
      
      initScrollTop: function(){
      e().UItoTop({ easingType: 'easeOutQuart' });
      },
  
     

      
             initMobileMenu: function() {
            if (e(".menu-block").is(':visible')) {
                e(".gf-menu-device-container ul.gf-menu li.dropdown").each(function() {
                    if (e(this).find("> p.toogleClick").length == 0) {
                        e(this).prepend('<p class="toogleClick">+</p>');
                    }
                });

                if (e(".menu-block").children().hasClass("gf-menu-device-wrapper") == false) {
                    e(".menu-block").children().addClass("gf-menu-device-wrapper");
                }
                if (e(".gf-menu-device-container").find("ul.gf-menu").size() == 0) {
                    var vfeNav = document.querySelector('#vf-empresas .vfe-main-menu, #vf-pymes .vfe-main-menu, .vf-nav-mobile-vfe-source .vfe-main-menu');
                    if (!vfeNav) {
                    var n = e(".vf-nav-mobile-source .site-nav-dropdown_inner");
                    if (n.length === 0) n = e(".nav-bar .site-nav-dropdown_inner");
                    e(".gf-menu-device-container").append(n.first().html());
                    e(".gf-menu-device-container .site-nav").addClass("gf-menu");
                    e(".gf-menu-device-container .site-nav").removeClass("nav")
                    }
                }
                e("p.toogleClick").click(function() {
                    if (e(this).hasClass("mobile-toggle-open")) {
                        e(this).next().next().hide();
                        e(this).removeClass("mobile-toggle-open");
                    } else {
                        e(this).next().next().show();
                        e(this).addClass("mobile-toggle-open")
                    }
                });
               var w = window.innerWidth;
                  if (w < 967) {
                    jQuery('.site-nav .dropdown .menu__moblie').bind('click', function(event) {
                      if (currentEl != this) {
                        e(this).next().show();
                        e(this).prev().addClass('mobile-toggle-open');
                        event.preventDefault();
                        currentEl = this;
                      }
                    });
                  }
                e("p.toogleClick").show();
                e("div.gf-menu-toggle").hide();
                e(".nav-bar .site-nav-dropdown_inner").hide();
                if (e("ul.gf-menu").hasClass("clicked") == false) {
                    e(".gf-menu").hide();
                    e(".gf-menu li.dropdown ul.site-nav-dropdown").hide();
                }


                e(".col-1 .inner ul.dropdown").parent().each(function() {
                    if (e(this).find("> p.toogleClick").length == 0) {
                        e(this).prepend('<p class="toogleClick">+</p>');
                    }
                });

                e(".cbp-spmenu span.icon-dropdown").remove();

                e("ul.gf-menu li.dropdown").each(function() {
                    if (e(this).find("> p.toogleClick").length == 0) {
                        e(this).prepend('<p class="toogleClick">+</p>');
                    }
                });

                e("p.toogleClick").click(function() {
                    if (e(this).hasClass("mobile-toggle-open")) {
                        e(this).next().next().hide();
                        e(this).removeClass("mobile-toggle-open");
                    } else {
                        e(this).next().next().show();
                        e(this).addClass("mobile-toggle-open");
                    }
                });
                e('.header-panel-bottom ul.customer-links').prependTo(e('.customer-area .dropdown-menu'));
            } else {
                e(".nav-bar .site-nav-dropdown_inner").show();
                e(".gf-menu").hide();

               
            }
            if (e(".menu-block").children().hasClass("gf-menu-device-wrapper") == false) {
                e(".menu-block").children().addClass("resized");
            };
        },
      
      initShortcode: function() {
       e('.dt-sc-toggle').toggle(function(){ e(this).addClass('active'); },function(){ e(this).removeClass('active'); });
	   e('.dt-sc-toggle').click(function(){ e(this).next('.dt-sc-toggle-content').slideToggle(); });
	   e('.dt-sc-toggle-frame-set').each(function(){
		var $this = e(this),
		$toggle = $this.find('.dt-sc-toggle-accordion');
		
		$toggle.click(function(){
			if( e(this).next().is(':hidden') ) {
				$this.find('.dt-sc-toggle-accordion').removeClass('active').next().slideUp();
				e(this).toggleClass('active').next().slideDown();
			}
			return false;
		});
		
		//Activate First Item always
		$this.find('.dt-sc-toggle-accordion:first').addClass("active");
		$this.find('.dt-sc-toggle-accordion:first').next().slideDown();
	});/* Toggle Shortcode end*/
    
    //TABS...
	if(e('ul.tabs').length > 0) {
	  e('ul.tabs').tabs('> .dt-sc-tabs_content');
	}
	
	if(e('ul.dt-sc-tabs-frame').length > 0){
	e('ul.dt-sc-tabs-frame').tabs('> .dt-sc-tabs-frame-content');
	}
	
	if(e('ul.tabs').length > 0) {
		e('ul.tabs').tabs('> .dt-sc-tabs_content');
	}
	
	if(e('.dt-sc-tabs').length > 0) {
		e('.dt-sc-tabs').tabs('> .dt-sc-tabs-content');
	}
  
	if(e('.dt-sc-tabs-vertical-frame').length > 0){
	
		e('.dt-sc-tabs-vertical-frame').tabs('> .dt-sc-tabs-vertical-frame-content');
		
		e('.dt-sc-tabs-vertical-frame').each(function(){
			e(this).find("li:first").addClass('first').addClass('current');
			e(this).find("li:last").addClass('last');
		});
		
		e('.dt-sc-tabs-vertical-frame li').click(function(){
			e(this).parent().children().removeClass('current');
			e(this).addClass('current');
		});
		
	}
  
      },
      
     
      
        initWishlist: function() {
           t.updateWishlistButtons()
           t.initWishlistButtons()
        },
       
      

      initWishlistButtons: function() {
        if(e(".add-in-wishlist-js").length == 0) {
          return false;
        }
        e(".add-in-wishlist-js").each(function(){
          e(this).unbind();
          e(this).click(function(event){
            console.log("adas");
            event.preventDefault();
            try
            {
              var id = e(this).attr('href');
              if(e.cookie(cookieName) == null) {
                var str = id;
              } else {
                if(e.cookie(cookieName).indexOf(id) == -1) {
                  var str = e.cookie(cookieName) + '__' + id;
                }
              }
              e.cookie(cookieName, str, {expires:14, path:'/'});
              jQuery('.loadding-wishbutton-'+id).show();
              jQuery('.default-wishbutton-'+id).remove();
              setTimeout(function(){ jQuery('.loadding-wishbutton-'+id).remove(); jQuery('.added-wishbutton-'+id).show(); }, 2000);
              e(this).unbind();
            }
            catch (err) {} // ignore errors reading cookies
          })
        });
      },


      updateWishlistButtons: function() {
        try
        {
          if(e.cookie(cookieName) != null && e.cookie(cookieName) != '__' && e.cookie(cookieName) != '') {
            var str = String(e.cookie(cookieName)).split("__");
            for (var i=0; i<str.length; i++) {
              if (str[i] != '') {
                jQuery('.added-wishbutton-'+str[i]).show();
                jQuery('.default-wishbutton-'+str[i]).remove();
                jQuery('.loadding-wishbutton-'+str[i]).remove();

              }
            }
          }
        }
        catch (err) {}
      },


      
      
      
       initelevateZoom: function() {
            /* Desactivado: galería Vivofácil en product-gallery.js (sin lupa hover) */
        },
      
    
      
      initProductMoreview: function() {
            if (e('.more-view-wrapper-owlslider').length > 0) {
                this.initOwlMoreview();
            } 
        },
      
     
       initOwlMoreview: function() {
       e(".more-view-wrapper-owlslider ul").owlCarousel({
            loop:false,
            margin:10,
            nav:true,
            navContainer: ".single-page-owl-carousel",
            navText: ['<a class="prev"><i class="icon-arrow-left icons" ></i></a>','<a class="next"><i class="icon-arrow-right icons" ></i></a>'],
            dots: false,
            responsive:{
                0:{
                    items:3
                },
                600:{
                    items:3
                },
                1000:{
                    items:4
                }
            }
        });
        },
        
      
        initProductWishlist: function() {
            e(".product-single button.wishlist").click(function(n) {
                n.preventDefault();
                var r = e(this).parent();
                var i = r.parents(".grid-item");
                e.ajax({
                    type: "POST",
                    url: "/contact",
                    data: r.serialize(),
                    beforeSend: function() {
                        t.showLoading()
                    },
                    success: function(n) {
                        t.hideLoading();                  
                       var o = e("#product-featured-image").attr("src");
                       var wp = e(".product-single__title").text();
                       var wamt = e(".product-single__price .grid-link__org_price span.money").text();   
                       
                      e(".ajax-success-modal").find(".added-to-wishlist").show();
                      e(".ajax-success-modal").find(".added-to-cart").hide();
                      e(".ajax-success-modal").find(".ajax-product-image").attr("src", o);    
                      e(".ajax-success-modal").find(".ajax-product-title").text(wp);
                      e(".ajax-success-modal").find(".ajax_price").text(wamt);
                      //e(".ajax-success-modal").find(".ajax_qty").text(wamt);
                      
                      
                      t.showModal(".ajax-success-modal")
                    },
                    error: function(n, r) {
                        t.hideLoading();
                        e(".loading-modal").hide();
                        e(".ajax-error-message").text(e.parseJSON(n.responseText).description);
                        t.showModal(".ajax-error-modal")
                    }
                })
            })
        },
      
        showModal: function(n) {
            e(n).fadeIn(500);
            t.KidsTimeout = setTimeout(function() {
                e(n).fadeOut(500)
            }, 5e3)
        },
        checkItemsInDropdownCart: function() {
            if (e("#slidedown-cart .mini-products-list").children().length > 0) {
                e("#slidedown-cart .no-items").hide();
                e("#slidedown-cart .has-items").css("display", "flex")
            } else {
                e("#slidedown-cart .has-items").hide();
                e("#slidedown-cart .no-items").css("display", "flex")
            }
        },
        initModal: function() {
            e(".continue-shopping").click(function() {
                clearTimeout(t.KidsTimeout);
                e(".ajax-success-modal").fadeOut(500)
            });
            e(".close-modal, .overlay").click(function() {
                clearTimeout(t.KidsTimeout);
                e(".ajax-success-modal, .compare_modal").fadeOut(500)
            })
        },
        initDropDownCart: function() {
            // ── Sidebar lateral: siempre se activa con click ──────────────────
            t._cartSidebarOpen = false;

            // Abrir sidebar al hacer click en el icono del carrito
            e("#ToggleDown").on("click", function(n) {
                n.preventDefault();
                t.openCartSidebar();
            });

            // Cerrar con el botón X interno
            e(document).on("click", "#vf-cart-close", function() {
                t.closeDropdownCart();
            });

            // Cerrar al hacer click en el overlay
            e(document).on("click", "#vf-cart-overlay", function() {
                t.closeDropdownCart();
            });

            // Cerrar con Escape (ya existe en el listener global de keyup)

            // "Continuar comprando" en estado vacío cierra el sidebar
            e(document).on("click", "#slidedown-cart .no-items a, #vf-cart-continue-btn", function() {
                t.closeDropdownCart();
            });

            // Añadir PRIME desde el banner del carrito → abre modal de planes
            e(document).on("click", "#vf-cart-prime-add", function() {
                t._addPrimeFromCartBanner();
            });

            // Cerrar modal PRIME (páginas sin handlers propios del producto)
            e(document).on("click", "#primeModal .prime-modal-close, #primeModal .btn-cancelar, #primeModal .prime-modal-overlay", function() {
                t.cerrarModalPrime();
            });

            // Desde el minicarrito: elegir plan solo añade la suscripción (no el servicio otra vez)
            document.addEventListener("click", function(ev) {
                if (t._primeModalContext !== "minicart") return;
                var btn = ev.target && ev.target.closest && ev.target.closest("#primeModal .btn-prime-seleccionar");
                if (!btn) return;
                ev.preventDefault();
                ev.stopPropagation();
                ev.stopImmediatePropagation();
                var $opcion = e(btn).closest(".prime-opcion");
                var primeHandle = $opcion.data("primeHandle") || $opcion.attr("data-prime-handle");
                if (primeHandle) {
                    t._addPrimeSubscriptionFromModal(primeHandle);
                }
            }, true);

            // Eliminar producto
            e(document).on("click", "#slidedown-cart .btn-remove", function(n) {
                n.preventDefault();
                var r = e(this).parents(".item").attr("id");
                r = r.match(/\d+/g);
                Shopify.removeItem(r, function(cartData) {
                    t.doUpdateDropdownCart(cartData);
                });
            });

            // Checkbox de T&C → habilita/deshabilita el botón de pago
            e(document).on("change", "#vf-cart-terms-checkbox", function() {
                t._updateCheckoutButton();
            });

            // Botón DECREMENTAR cantidad
            e(document).on("click", "#slidedown-cart .vf-qty-dec", function() {
                var $control = e(this).closest(".vf-qty-control");
                var $item = e(this).closest(".item");
                var itemId   = $control.data("item-id");
                var $val     = $control.find(".vf-qty-control__value");
                var current  = parseInt($val.text(), 10);
                var minQty   = t._getItemMinQtyFromEl($item, $control);

                if (current <= minQty) {
                    t._showMinQtyNotice(minQty, $item);
                    return;
                }

                var newQty = current - 1;
                t._updateItemQty(itemId, newQty, $control);
            });

            // Botón INCREMENTAR cantidad
            e(document).on("click", "#slidedown-cart .vf-qty-inc", function() {
                var $control = e(this).closest(".vf-qty-control");
                var $item = e(this).closest(".item");
                var handle = $item.data("productHandle") || $item.attr("data-product-handle") || "";

                if (t._isPrimeProductHandle(handle)) {
                    if (typeof window.vfShowPrimeSingleSubscriptionNotice === "function") {
                        window.vfShowPrimeSingleSubscriptionNotice();
                    } else {
                        e(".ajax-error-message").text(window.vfPrimeSingleSubscriptionMessage || "Solo se permite 1 suscripción PRIME en el carrito.");
                        t.showModal(".ajax-error-modal");
                    }
                    return;
                }

                var itemId   = $control.data("item-id");
                var $val     = $control.find(".vf-qty-control__value");
                var current  = parseInt($val.text(), 10);
                var newQty   = current + 1;
                t._updateItemQty(itemId, newQty, $control);
            });

            // Botón de pago: sólo actúa si el checkbox está marcado
            e(document).on("click", "#vf-cart-checkout-btn", function() {
                if (!e("#vf-cart-terms-checkbox").is(":checked")) {
                    e("#vf-cart-terms-error").removeAttr("hidden");
                    e("#vf-cart-terms-checkbox").focus();
                    return;
                }
                e("#vf-cart-terms-error").attr("hidden", true);
                window.location = "/checkout";
            });

            t.checkItemsInDropdownCart();
        },

        _updateCheckoutButton: function() {
            var checked = e("#vf-cart-terms-checkbox").is(":checked");
            var btn = e("#vf-cart-checkout-btn");
            if (checked) {
                btn.removeClass("vf-cart-sidebar__checkout--disabled").attr("aria-disabled", "false");
                e("#vf-cart-terms-error").attr("hidden", true);
            } else {
                btn.addClass("vf-cart-sidebar__checkout--disabled").attr("aria-disabled", "true");
            }
        },

        _updateItemQty: function(itemId, newQty, $control) {
            var $item = $control ? $control.closest(".item") : e();
            var handle = $item.data("productHandle") || $item.attr("data-product-handle") || "";
            var minQty = t._getItemMinQtyFromEl($item, $control);

            if (t._isPrimeProductHandle(handle) && newQty > 1) {
                if (typeof window.vfShowPrimeSingleSubscriptionNotice === "function") {
                    window.vfShowPrimeSingleSubscriptionNotice();
                } else {
                    e(".ajax-error-message").text(window.vfPrimeSingleSubscriptionMessage || "Solo se permite 1 suscripción PRIME en el carrito.");
                    t.showModal(".ajax-error-modal");
                }
                return;
            }

            if (newQty < minQty) {
                t._showMinQtyNotice(minQty, $item);
                return;
            }

            // Deshabilitar los botones mientras se procesa
            $control.find(".vf-qty-control__btn").prop("disabled", true);

            Shopify.changeItem(itemId, newQty, function(cartData) {
                t.doUpdateDropdownCart(cartData);
                // doUpdateDropdownCart reconstruye la lista completa,
                // los botones se re-renderizan, no hace falta rehabilitar manualmente
            });
        },

        _getItemMinQty: function(item) {
            if (!item) return 1;
            if (t._isPrimeProductHandle(item.handle)) return 1;

            var handle = String(item.handle || "").toLowerCase();
            if (handle.indexOf("cuota-de-alta") === 0 || handle.indexOf("cuota-alta") === 0) {
                return 1;
            }

            var unidad = t._getItemUnidad(item);
            if (t._isPlanOrCuotaItem(item)) return 1;

            if (item.properties && item.properties._min_qty != null && item.properties._min_qty !== "") {
                var fromProp = parseInt(item.properties._min_qty, 10);
                if (!isNaN(fromProp) && fromProp > 0) return fromProp;
            }

            if (handle && t._minQtyPorHandle[handle] != null) {
                var fromCache = parseInt(t._minQtyPorHandle[handle], 10);
                if (!isNaN(fromCache) && fromCache > 0) return fromCache;
            }

            return unidad.sing === "hora" ? 3 : 1;
        },

        _getItemMinQtyFromEl: function($item, $control) {
            var fromControl = parseInt($control && $control.data("min-qty"), 10);
            if (!isNaN(fromControl) && fromControl > 0) return fromControl;

            var fromItem = parseInt($item && $item.data("min-qty"), 10);
            if (!isNaN(fromItem) && fromItem > 0) return fromItem;

            var handle = $item.data("productHandle") || $item.attr("data-product-handle") || "";
            if (t._isPrimeProductHandle(handle)) return 1;

            if (handle && t._minQtyPorHandle[String(handle).toLowerCase()] != null) {
                var fromCache = parseInt(t._minQtyPorHandle[String(handle).toLowerCase()], 10);
                if (!isNaN(fromCache) && fromCache > 0) return fromCache;
            }

            var unidad = ($item.data("unidad") || $item.attr("data-unidad") || "").toString().toLowerCase();
            if (unidad === "hora") return 3;
            return 1;
        },

        _showMinQtyNotice: function(minQty, $item) {
            var unidad = ($item && ($item.data("unidad") || $item.attr("data-unidad")) || "").toString().toLowerCase();
            var forms = t._unidadForms(unidad);
            var label = minQty === 1 ? (forms.sing || "unidad") : (forms.abbr ? forms.abbr : (forms.plur || "unidades"));
            var message = forms.abbr
                ? ("El servicio mínimo es de " + minQty + " " + forms.abbr + ".")
                : ("El servicio mínimo es de " + minQty + " " + label + ".");

            if (typeof window.vfShowStoreNotice === "function") {
                window.vfShowStoreNotice({
                    title: "Cantidad mínima",
                    message: message,
                    variant: "warning"
                });
            } else {
                e(".ajax-error-message").text(message);
                t.showModal(".ajax-error-modal");
            }
        },

        _getLineProperty: function(item, key) {
            if (!item || !item.properties) return "";
            var props = item.properties;

            if (props[key] != null && props[key] !== "") {
                return String(props[key]).trim();
            }

            if (Array.isArray(props)) {
                for (var i = 0; i < props.length; i++) {
                    var entry = props[i];
                    if (entry && entry.name === key && entry.value != null && entry.value !== "") {
                        return String(entry.value).trim();
                    }
                }
            }

            return "";
        },

        _isPrimeExcludedUnidad: function(unidad) {
            var u = String(unidad || "").trim().toLowerCase();
            return u === "plan" || u === "cuota";
        },

        _isPlanOrCuotaItem: function(item) {
            if (!item) return false;
            if (t._isPrimeProductHandle(item.handle)) return false;

            var handle = String(item.handle || "").toLowerCase();
            if (handle.indexOf("cuota-de-alta") === 0 || handle.indexOf("cuota-alta-") === 0) {
                return true;
            }

            if (item.selling_plan_allocation) {
                return true;
            }

            return t._isPrimeExcludedUnidad(t._getItemUnidad(item).sing);
        },

        _isPrimeProductHandle: function(handle) {
            if (!handle) return false;
            handle = handle.toLowerCase();
            return handle === "prime-mensual" || handle === "prime-anual" || handle === "suscripcion-prime";
        },

        _getCartItemSubtitle: function(item) {
            if (t._isPrimeProductHandle(item.handle)) {
                if (item.handle === "prime-mensual") return "Suscripción mensual";
                if (item.handle === "prime-anual") return "Suscripción anual";
                return "Suscripción PRIME";
            }

            var variantTitle = item.variant_title || "";
            if (!variantTitle || variantTitle.indexOf("Default") !== -1) {
                variantTitle = "";
            }

            var parts = variantTitle.split(" / ");
            var horarioRaw = (parts[0] || "").trim();
            var provincia = (parts[1] || "").trim();
            var horario = horarioRaw;

            if (horarioRaw.indexOf("Laboral") !== -1) horario = "Laboral";
            else if (horarioRaw.indexOf("Festivo") !== -1) horario = "Festivo";
            else if (!horarioRaw || horarioRaw.indexOf("Default") !== -1) horario = "";

            var unidad = t._getItemUnidad(item);
            var qtyLabel = "";

            if (unidad.abbr) {
                qtyLabel = item.quantity + " " + unidad.abbr;
            } else if (unidad.displaySing) {
                qtyLabel = item.quantity + " " + (item.quantity === 1 ? unidad.displaySing : unidad.displayPlur);
            } else if (unidad.sing) {
                qtyLabel = item.quantity + " " + (item.quantity === 1 ? unidad.sing : unidad.plur);
            } else {
                qtyLabel = String(item.quantity);
            }

            return [qtyLabel, provincia, horario].filter(function(parte) {
                return parte;
            }).join(" · ");
        },

        _unidadPorHandle: {},
        _minQtyPorHandle: {},

        _cacheUnidadesDesdeDOM: function() {
            e("#slidedown-cart .mini-products-list .item").each(function() {
                var $li = e(this);
                var unidad = $li.data("unidad");
                var handle = $li.data("productHandle");
                if (unidad && handle && !t._isPrimeProductHandle(handle)) {
                    t._unidadPorHandle[String(handle).toLowerCase()] = unidad;
                }
            });
        },

        _cacheMinQtyDesdeDOM: function() {
            e("#slidedown-cart .mini-products-list .item").each(function() {
                var $li = e(this);
                var handle = $li.data("productHandle") || $li.attr("data-product-handle");
                if (!handle || t._isPrimeProductHandle(handle)) return;

                var minQty = parseInt($li.data("min-qty"), 10);
                if (isNaN(minQty) || minQty <= 0) {
                    minQty = parseInt($li.find(".vf-qty-control").data("min-qty"), 10);
                }
                if (!isNaN(minQty) && minQty > 0) {
                    t._minQtyPorHandle[String(handle).toLowerCase()] = minQty;
                }
            });
        },

        _getItemUnidad: function(item) {
            if (t._isPrimeProductHandle(item.handle)) {
                return t._unidadForms("mes");
            }

            var raw = t._getLineProperty(item, "_unidad");

            if (!raw && item.handle) {
                var handleKey = String(item.handle).toLowerCase();
                if (t._unidadPorHandle[handleKey]) {
                    raw = t._unidadPorHandle[handleKey];
                }
            }

            if (!raw) {
                var productType = (item.product_type || "").toLowerCase();
                if (productType.indexOf("sesion") !== -1 || productType.indexOf("sesión") !== -1) {
                    raw = "sesión";
                }
            }

            return t._unidadForms(String(raw || "").trim().toLowerCase(), t._getLineProperty(item, "_periodo_precio"));
        },

        _unidadForms: function(sing, periodoPrecio) {
            sing = String(sing || "").trim().toLowerCase();
            periodoPrecio = String(periodoPrecio || "").trim().toLowerCase();
            if (!sing) {
                return { sing: "", plur: "", abbr: "", displaySing: "", displayPlur: "" };
            }

            var plur;
            if (sing.indexOf("ión") !== -1) {
                plur = sing.replace("ión", "iones");
            } else if (/[aeiou]$/.test(sing)) {
                plur = sing + "s";
            } else if (/z$/.test(sing)) {
                plur = sing.slice(0, -1) + "ces";
            } else {
                plur = sing + "es";
            }

            var displaySing = sing;
            var displayPlur = plur;
            if (sing === "plan") {
                displaySing = periodoPrecio || "año";
                var displayForms = t._unidadForms(displaySing);
                displayPlur = displayForms.plur;
            }

            return {
                sing: sing,
                plur: plur,
                abbr: sing === "hora" ? "h" : "",
                displaySing: displaySing,
                displayPlur: displayPlur
            };
        },

        _isPrimeCustomer: function() {
            if (typeof window.vfCustomerIsPrime !== "undefined") {
                return !!window.vfCustomerIsPrime;
            }
            var $cart = e("#slidedown-cart");
            var flag = $cart.data("customerIsPrime");
            return flag === true || flag === "true";
        },

        _shouldShowPrimePricing: function(cart) {
            return t._isPrimeCustomer() || t._cartHasPrime(cart);
        },

        _primeDiscountPorHandle: {},

        _cachePrimeDiscountDesdeDOM: function() {
            e("#slidedown-cart .mini-products-list .item").each(function() {
                var $li = e(this);
                var handle = $li.data("productHandle");
                var discount = parseFloat($li.data("primeDiscount"));
                if (handle && !isNaN(discount) && discount > 0) {
                    t._primeDiscountPorHandle[handle] = discount;
                }
            });
        },

        _getItemPrimeDiscount: function(item) {
            if (t._isPlanOrCuotaItem(item)) {
                return 0;
            }

            if (item.properties && item.properties._prime_discount) {
                var fromProp = parseFloat(item.properties._prime_discount);
                if (!isNaN(fromProp) && fromProp > 0) {
                    return fromProp;
                }
            }

            var $line = e("#cart-item-" + item.id);
            if ($line.length) {
                var fromData = parseFloat($line.data("primeDiscount"));
                if (!isNaN(fromData) && fromData > 0) {
                    return fromData;
                }
            }

            if (item.handle && t._primeDiscountPorHandle[item.handle]) {
                return t._primeDiscountPorHandle[item.handle];
            }

            return 0;
        },

        _itemHasPrimeDiscount: function(item) {
            return t._getItemPrimeDiscount(item) > 0;
        },

        _getPrimeDiscountFromForm: function() {
            var $input = e('#AddToCartForm input[name="properties[_prime_discount]"]');
            if ($input.length) {
                var fromInput = parseFloat($input.val());
                if (!isNaN(fromInput) && fromInput > 0) {
                    return fromInput;
                }
            }

            var $form = e("#AddToCartForm");
            if (!$form.length) {
                return 0;
            }

            var raw = $form.data("primeDiscount");
            if (raw === undefined || raw === null || raw === "") {
                raw = $form.attr("data-prime-discount");
            }

            if (raw === undefined || raw === null || raw === "") {
                return 0;
            }

            var discount = parseFloat(raw);
            return !isNaN(discount) && discount > 0 ? discount : 0;
        },

        _getUnidadFromForm: function() {
            var $input = e('#AddToCartForm input[name="properties[_unidad]"]');
            if ($input.length && $input.val()) {
                return $input.val();
            }
            return window.vfUnidad && window.vfUnidad.sing ? window.vfUnidad.sing : "";
        },

        _getMinQtyFromForm: function() {
            var $input = e('#AddToCartForm input[name="properties[_min_qty]"]');
            if ($input.length && $input.val()) {
                var n = parseInt($input.val(), 10);
                if (!isNaN(n) && n > 0) return n;
            }
            if (window.vfMinQty > 0) return window.vfMinQty;
            return 0;
        },

        // Precio de línea a tarifa estándar (sin PRIME). Si Shopify aplicó descuento por error,
        // original_line_price refleja el importe correcto para clientes sin PRIME.
        _getItemStandardLineCents: function(item) {
            if (t._isPrimeProductHandle(item.handle)) {
                return item.line_price;
            }

            if (t._isPlanOrCuotaItem(item)) {
                if (item.original_line_price && item.original_line_price > item.line_price) {
                    return item.original_line_price;
                }
                return item.line_price;
            }

            if (item.original_line_price && item.original_line_price > item.line_price) {
                return item.original_line_price;
            }

            return item.line_price;
        },

        _calcCartStandardSubtotal: function(cart) {
            var sum = 0;
            if (!cart || !cart.items) {
                return 0;
            }

            for (var i = 0; i < cart.items.length; i++) {
                sum += t._getItemStandardLineCents(cart.items[i]);
            }

            return sum;
        },

        _getCartDisplayTotals: function(cart) {
            if (t._shouldShowPrimePricing(cart)) {
                return {
                    subtotal: cart.items_subtotal_price,
                    total: cart.total_price
                };
            }

            var standardSubtotal = t._calcCartStandardSubtotal(cart);
            return {
                subtotal: standardSubtotal,
                total: standardSubtotal
            };
        },

        _getAddLineItemDisplayCents: function(lineItem, quantity) {
            var qty = quantity > 0 ? quantity : (lineItem.quantity || 1);
            var lineCents = lineItem.final_line_price || lineItem.line_price || (lineItem.price * qty);
            var originalLineCents = lineItem.original_line_price;

            if (!originalLineCents && lineItem.original_price) {
                originalLineCents = lineItem.original_price * qty;
            }

            var pseudoItem = {
                handle: lineItem.handle,
                line_price: lineCents,
                original_line_price: originalLineCents || lineCents,
                price: lineItem.price,
                quantity: qty,
                properties: lineItem.properties || {}
            };

            if (t._isPrimeCustomer()) {
                var addDiscount = t._getPrimeDiscountFromForm();
                if (addDiscount <= 0 && typeof window.vfGetPrimeDiscountPct === "function") {
                    addDiscount = window.vfGetPrimeDiscountPct();
                }
                if (addDiscount <= 0) {
                    addDiscount = t._getItemPrimeDiscount(pseudoItem);
                }
                if (addDiscount > 0 && typeof window.vfCalcPrimeLineCents === "function") {
                    return window.vfCalcPrimeLineCents(lineItem.price, qty, addDiscount);
                }
                if (originalLineCents && originalLineCents > lineCents) {
                    return lineCents;
                }
            }

            return t._getItemStandardLineCents(pseudoItem);
        },

        // Redondeo por unidad (céntimos), luego × qty — misma regla que ficha y Function PRIME
        _calcItemPrimePrices: function(unitPriceCents, quantity, discount) {
            var qty = quantity > 0 ? quantity : 1;
            var primeUnit = Math.round(unitPriceCents * (100 - discount) / 100);
            var savingsPerUnit = unitPriceCents - primeUnit;
            return {
                primeUnit: primeUnit,
                primeLine: primeUnit * qty,
                savings: savingsPerUnit * qty
            };
        },

        _buildLinePriceHtml: function(item, showPrime) {
            if (t._isPrimeProductHandle(item.handle)) {
                return '<span class="price money">' + Shopify.formatMoney(item.line_price, window.money_format) + "</span>";
            }

            if (t._isPlanOrCuotaItem(item)) {
                var planLineCents = item.line_price;
                if (item.original_line_price && item.original_line_price > item.line_price) {
                    planLineCents = item.original_line_price;
                }
                return '<span class="price money">' + Shopify.formatMoney(planLineCents, window.money_format) + "</span>";
            }

            if (!showPrime) {
                return '<span class="price money">' + Shopify.formatMoney(t._getItemStandardLineCents(item), window.money_format) + "</span>";
            }

            // Preferir descuento real de la Shopify Function (original vs line)
            if (item.original_line_price && item.original_line_price > item.line_price) {
                return ''
                    + '<span class="price price--standard money"><s>' + Shopify.formatMoney(item.original_line_price, window.money_format) + "</s></span>"
                    + '<span class="price price--prime money">' + Shopify.formatMoney(item.line_price, window.money_format) + "</span>";
            }

            // Fallback: estimar desde metafield/property si aún no hay descuento aplicado
            var discount = t._getItemPrimeDiscount(item);
            if (discount <= 0) {
                return '<span class="price money">' + Shopify.formatMoney(item.line_price, window.money_format) + "</span>";
            }

            var prices = t._calcItemPrimePrices(item.price, item.quantity, discount);

            return ''
                + '<span class="price price--standard money"><s>' + Shopify.formatMoney(item.line_price, window.money_format) + "</s></span>"
                + '<span class="price price--prime money">' + Shopify.formatMoney(prices.primeLine, window.money_format) + "</span>";
        },

        _calcPrimeSavingsEstimate: function(cart) {
            var savings = 0;

            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                if (t._isPrimeProductHandle(item.handle)) continue;
                if (t._isPlanOrCuotaItem(item)) continue;
                var discount = t._getItemPrimeDiscount(item);
                if (discount <= 0) continue;
                savings += t._calcItemPrimePrices(item.price, item.quantity, discount).savings;
            }

            return savings;
        },

        _calcAppliedPrimeSavings: function(cart) {
            var savings = 0;

            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                if (t._isPrimeProductHandle(item.handle)) continue;
                if (t._isPlanOrCuotaItem(item)) continue;
                var original = item.original_line_price != null ? item.original_line_price : item.line_price;
                if (original > item.line_price) {
                    savings += original - item.line_price;
                }
            }

            return savings;
        },

        _calcPrimeSavings: function(cart) {
            return t._calcPrimeSavingsEstimate(cart);
        },

        _cartHasPrime: function(cart) {
            for (var i = 0; i < cart.items.length; i++) {
                if (t._isPrimeProductHandle(cart.items[i].handle)) return true;
            }
            return false;
        },

        _updatePrimeState: function(cart) {
            var showPrime = t._shouldShowPrimePricing(cart);
            var displayTotals = t._getCartDisplayTotals(cart);
            var $sidebar = e("#slidedown-cart");
            var $upsell = e("#vf-cart-prime-upsell");
            var $member = e("#vf-cart-prime-member");
            var $discountRow = e("#vf-cart-prime-discount-row");
            var hasPrimeProduct = t._cartHasPrime(cart);
            var appliedSavings = t._calcAppliedPrimeSavings(cart);
            var estimatedSavings = t._calcPrimeSavingsEstimate(cart);

            $sidebar.toggleClass("vf-cart-sidebar--prime-member", showPrime);

            if (showPrime) {
                $upsell.addClass("vf-cart-prime-banner--hidden").attr("hidden", true);
                if (cart.item_count > 0) {
                    e("#vf-cart-member-savings").html(Shopify.formatMoney(appliedSavings, window.money_format));
                    $member.removeClass("vf-cart-prime-banner--hidden").removeAttr("hidden");
                } else {
                    $member.addClass("vf-cart-prime-banner--hidden").attr("hidden", true);
                }

                e("#vf-cart-total").html(Shopify.formatMoney(displayTotals.total, window.money_format));
                e("#vf-cart-subtotal").html(Shopify.formatMoney(displayTotals.subtotal, window.money_format));

                if (appliedSavings > 0 && cart.item_count > 0) {
                    e("#vf-cart-prime-discount").html("−" + Shopify.formatMoney(appliedSavings, window.money_format));
                    $discountRow.removeClass("vf-cart-sidebar__prime-discount--hidden").removeAttr("hidden");
                } else {
                    $discountRow.addClass("vf-cart-sidebar__prime-discount--hidden").attr("hidden", true);
                }
            } else {
                $member.addClass("vf-cart-prime-banner--hidden").attr("hidden", true);
                $discountRow.addClass("vf-cart-sidebar__prime-discount--hidden").attr("hidden", true);
                e("#vf-cart-total").html(Shopify.formatMoney(displayTotals.total, window.money_format));
                e("#vf-cart-subtotal").html(Shopify.formatMoney(displayTotals.subtotal, window.money_format));

                if (cart.item_count > 0 && !hasPrimeProduct) {
                    e("#vf-cart-prime-savings").html(Shopify.formatMoney(estimatedSavings, window.money_format));
                    $upsell.removeClass("vf-cart-prime-banner--hidden").removeAttr("hidden");
                } else {
                    $upsell.addClass("vf-cart-prime-banner--hidden").attr("hidden", true);
                }
            }
        },

        _addPrimeFromCartBanner: function() {
            if (typeof window.vfEnsureSinglePrimeSubscription === "function") {
                window.vfEnsureSinglePrimeSubscription().then(function() {
                    t._openPrimeUpsellModal();
                }).catch(function(error) {
                    var message = (error && error.description) ? error.description : (window.vfPrimeSingleSubscriptionMessage || "Solo se permite 1 suscripción PRIME en el carrito.");
                    if (typeof window.vfShowPrimeSingleSubscriptionNotice === "function") {
                        window.vfShowPrimeSingleSubscriptionNotice(message);
                    } else {
                        e(".ajax-error-message").text(message);
                        t.showModal(".ajax-error-modal");
                    }
                });
                return;
            }

            t._openPrimeUpsellModal();
        },

        _openPrimeUpsellModal: function() {
            if (!e("#primeModal").length) {
                window.location = "/products/prime-anual";
                return;
            }
            t._primeModalContext = "minicart";
            t.mostrarModalPrime();
        },

        _addPrimeSubscriptionFromModal: function(primeHandle) {
            var planKey = String(primeHandle || "").replace("prime-", "");

            t.mostrarLoadingPrime();

            var onDone = function() {
                t.ocultarLoadingPrime();
                t.cerrarModalPrime();
                Shopify.getCart(function(cartData) {
                    t.doUpdateDropdownCart(cartData);
                    if (!t._cartSidebarOpen) {
                        t.openCartSidebar();
                    }
                });
            };

            var onError = function(error) {
                t.ocultarLoadingPrime();
                t.cerrarModalPrime();
                var message = (error && error.description) ? error.description : "No se pudo añadir la suscripción PRIME.";
                if (typeof window.vfShowPrimeSingleSubscriptionNotice === "function" && message.indexOf("PRIME") !== -1) {
                    window.vfShowPrimeSingleSubscriptionNotice(message);
                } else if (typeof window.vfShowStoreNotice === "function") {
                    window.vfShowStoreNotice({ title: "No se pudo añadir", message: message, variant: "error" });
                } else {
                    e(".ajax-error-message").text(message);
                    t.showModal(".ajax-error-modal");
                }
            };

            if (typeof window.vfAddPrimeSubscriptionToCart === "function") {
                window.vfAddPrimeSubscriptionToCart(planKey).then(onDone).catch(onError);
                return;
            }

            var variantId = t.getVariantIdByHandle("prime-" + planKey);
            if (!variantId) {
                onError({ description: "Plan PRIME no configurado en la tienda." });
                return;
            }

            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: { quantity: 1, id: variantId },
                dataType: "json",
                success: function() { onDone(); },
                error: function(xhr) {
                    var err = { description: "No se pudo añadir la suscripción PRIME." };
                    try {
                        err = jQuery.parseJSON(xhr.responseText) || err;
                    } catch (ex) {}
                    onError(err);
                }
            });
        },

        openCartSidebar: function() {
            e("#slidedown-cart").addClass("vf-cart-sidebar--open").attr("aria-hidden", "false");
            e("#vf-cart-overlay").addClass("vf-cart-overlay--visible").attr("aria-hidden", "false");
            e("#ToggleDown").attr("aria-expanded", "true");
            e("body").addClass("vf-cart-open");
            t._cartSidebarOpen = true;
            // Resetear checkbox y error cada vez que se abre
            e("#vf-cart-terms-checkbox").prop("checked", false);
            t._updateCheckoutButton();
        },

        closeDropdownCart: function() {
            e("#slidedown-cart").removeClass("vf-cart-sidebar--open").attr("aria-hidden", "true");
            e("#vf-cart-overlay").removeClass("vf-cart-overlay--visible").attr("aria-hidden", "true");
            e("#ToggleDown").attr("aria-expanded", "false");
            e("body").removeClass("vf-cart-open");
            t._cartSidebarOpen = false;
        },
       
        
        initProductAddToCart: function() {
            if (e("#AddToCart").length > 0) {
                e("#AddToCart").click(function(n) {
                    n.preventDefault();
                    if (e(this).attr("disabled") != "disabled") {
                        if (!window.ajax_cart) {
                            e(this).closest("form").submit()
                        } else {
                            var r = e("#AddToCartForm select[name=id]").val();
                            if (!r) {
                                r = e("#AddToCartForm input[name=id]").val()
                            }
                            var i = e("#AddToCartForm input[name=quantity]").val();
                            if (!i) {
                                i = 1
                            }                          
                            var o = e("#product-featured-image").attr("src");
                            var p = e(".product-single__title").text();
                            var amt = e(".product_single_price .grid-link__org_price span.money").text();      
                          console.log(amt);
                            t.doAjaxAddToCart(r, i, o, p, amt)
                        }
                    }
                    return false
                })
            }
        },
      initlightSlider: function() {
      if (e(".vertical").length > 0) {
      e('.vertical').lightSlider({      
      item:3,
      loop:false,
      slideMove:1,
      easing: 'linear',
      pager: false,
      speed:600,
      vertical:true,
     // currentPagerPosition: 'middle',
      verticalHeight:170,
      vThumbWidth:70,
        
      responsive : [
        {
          breakpoint:800,
          settings: {
            item:3,
            slideMove:1,
            slideMargin:4,                  
          }
        },
        {
          breakpoint:480,
          settings: {
            item:2,
            slideMove:1
          }
        }
      ]
    });  
             } 
    },
      
   initThumbchange: function() {
            if (e(".thumb_items img").length > 0) {
                e(".thumb_items img").click(function(n) {
                    n.preventDefault();                  
                    var r = e(this).parents(".item-row");
                    var i = e(r).attr("id");                                  
                    var photo_fullsize =  e(this).attr('src');							 
				   e(r).find(".grid-link img").attr('src', photo_fullsize); 
							  
                    })
                    //return false
            }
            },
      
    
        initAddToCart: function() {
            if (e(".add-cart-btn").length > 0) {
                e(".add-cart-btn").click(function(n) {
                    n.preventDefault();
                    if (e(this).attr("disabled") != "disabled") {
                        var r = e(this).parents(".item-row");
                        var i = e(r).attr("id");
                        i = i.match(/\d+/g);
                        if (!window.ajax_cart) {
                            e("#cart-form-" + i).submit()
                        } else {
                            var s = e("#cart-form-" + i + " select[name=id]").val();                          
                            if (!s) {
                                s = e("#cart-form-" + i + " input[name=id]").val()
                            }                          
                            var o = e("#cart-form-" + i + " select[name=quantity]").val();
                            if (!o) {
                                o = 1
                            }
                          console.log(o);
                           var a = e(r).find(".featured-image").attr("src");
                           var p = e(r).find(".grid-link__title").text();
                           var amt = e(r).find(".grid-link__meta .product_price .grid-link__org_price span.money").text();                         
                            t.doAjaxAddToCart(s, o, a, p, amt)
                        }
                    }
                    return false
                })
            }
        },
        showLoading: function() {
            e(".loading-modal").show()
        },
        hideLoading: function() {
            e(".loading-modal").hide()
        },
        doAjaxAddToCart: function(n, r, a, p, amt) {
            var cartData = "quantity=" + r + "&id=" + n;
            var primeDiscount = t._getPrimeDiscountFromForm();
            if (primeDiscount > 0) {
                cartData += "&properties[_prime_discount]=" + encodeURIComponent(primeDiscount);
            }
            var unidad = t._getUnidadFromForm();
            if (unidad) {
                cartData += "&properties[_unidad]=" + encodeURIComponent(unidad);
            }
            var minQty = t._getMinQtyFromForm();
            if (minQty > 0) {
                cartData += "&properties[_min_qty]=" + encodeURIComponent(minQty);
            }

            e.ajax({
                type: "post",
                url: "/cart/add.js",
                data: cartData,
                dataType: "json",
                beforeSend: function() {
                    t.showLoading()
                },
                success: function(lineItem) {
                    t.hideLoading();                    
                    t.showModal(".ajax-success-modal");
                     e(".ajax-success-modal").find(".ajax-product-image").attr("src", a);
                     e(".ajax-success-modal").find(".added-to-wishlist").hide();
                     e(".ajax-success-modal").find(".added-to-cart").show();
                     e(".ajax-success-modal").find(".ajax-product-title").text(p);
                    var linePrice = t._getAddLineItemDisplayCents(lineItem, r);
                    if (typeof window.vfSetCartSuccessModalPrice === 'function') {
                      window.vfSetCartSuccessModalPrice(linePrice);
                    } else {
                      e(".ajax-success-modal").find(".ajax_price").text(amt || Shopify.formatMoney(linePrice, window.money_format));
                    }
                    e(".ajax-success-modal").find(".ajax_qty").text(r);
                  
                    t.updateDropdownCart()
                },
                error: function(n, r) {
                    t.hideLoading();
                    e(".ajax-error-message").text(e.parseJSON(n.responseText).description);
                    t.showModal(".ajax-error-modal")
                }
            })
        },
       initQuickView: function() {
            e(".quick-view-text").click(function() {
              e('.quick-view').addClass('open-in');  
                var product = e(this).attr("id");
                Shopify.getProduct(product, function(product) {
                    var r = e("#quickview-template").html();
                    e(".quick-view").html(r);
                    var i = e(".quick-view");
                    var s = product.description.replace(/(<([^>]+)>)/ig, "");
                    s = s.split(" ").splice(0, 40).join(" ") + "...";
                    i.find(".product-title a").text(product.title);
                    i.find(".product-title a").attr("href", product.url);  
                   
                  if (i.find('.product-inventory span').length > 0) {
                      var variant = product.variants[0];
                      var inventoryInfo = i.find('.product-inventory span');                      
                      if (variant.available) {
                       if (variant.inventory_management != null) {
                          inventoryInfo.text(window.in_stock);
                        } else {
                          inventoryInfo.text(window.many_in_stock);
                        }
                      } else {
                        inventoryInfo.text(window.out_of_stock);
                      }
                    }
                  
                    
                    i.find(".product-description").text(s);
                   
                    i.find(".price").html(Shopify.formatMoney(product.price, window.money_format));
                    i.find(".product-item").attr("id", "product-" + product.id);
                    i.find(".variants").attr("id", "product-actions-" + product.id);
                    i.find(".variants select").attr("id", "product-select-" + product.id);
                    if (product.compare_at_price > product.price) {
                        i.find(".compare-price").html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                        i.find(".price").addClass("on-sale")
                    } else {
                        i.find(".compare-price").html("");
                        i.find(".price").removeClass("on-sale")
                    }
                    if (!product.available) {
                        i.find("select, input, .product_price, .total-price, .dec, .inc, .variants label").remove();
                        i.find(".add-to-cart-btn").text("Unavailable").addClass("disabled").attr("disabled", "disabled");                        
                    } else {
                      i.find(".product_price span").html(Shopify.formatMoney(product.price, window.money_format));     
                      i.find(".total-price span").html(Shopify.formatMoney(product.price, window.money_format));                        
                       if (window.use_color_swatch) {                        
                            t.createQuickViewVariantsSwatch(product, i);
                        } else {
                            t.createQuickViewVariants(product, i);
                        }
                        
                    }
                    i.find(".button").on("click", function() {
                        var n = i.find(".quantity").val(),
                            r = 1;
                        if (e(this).text() == "+") {
                            r = parseInt(n) + 1
                        } else if (n > 1) {
                            r = parseInt(n) - 1
                        }
                        i.find(".quantity").val(r);
                       if (i.find(".total-price").length > 0) {
                            t.updatePricingQuickview();
                        }
                    });
                  
                    t.loadQuickViewSlider(product, i);
                    t.initQuickviewAddToCart();
                    e(".quick-view").fadeIn(500);
                   
                   if (e('.quick-view .total-price').length > 0) {
                        e('.quick-view input[name=quantity]').on('change', t.updatePricingQuickview);
                    }
                });
                return false
                
                
                 if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                            }
              
            });
             e(".quick-view .overlay, .close-window").live("click", function() {
                t.closeQuickViewPopup();
               e('.quick-view').removeClass("open-in");
               e('.quick-view').removeClass("option-loader");
               
                return false
            })
           
        },
      
      
      
      updatePricingQuickview: function() {
            //try pattern one before pattern 2
            var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var unitPriceTextMatch = e('.quick-view .price').text().match(regex);

            if (!unitPriceTextMatch) {
                regex = /([0-9]+[.|,][0-9]+)/g;
                unitPriceTextMatch = e('.quick-view .price').text().match(regex);
            }

            if (unitPriceTextMatch) {
                var unitPriceText = unitPriceTextMatch[0];
                var unitPrice = unitPriceText.replace(/[.|,]/g, '');
                var quantity = parseInt(e('.quick-view input[name=quantity]').val());
                var totalPrice = unitPrice * quantity;

                var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
                regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
                if (!totalPriceText.match(regex)) {
                   regex = /([0-9]+[.|,][0-9]+)/g;
                } 
                totalPriceText = totalPriceText.match(regex)[0];

                var regInput = new RegExp(unitPriceText, "g");
                var totalPriceHtml = e('.quick-view #QProductPrice').html().replace(regInput, totalPriceText);

                $('.quick-view .total-price span').html(totalPriceHtml);
            }
        },
      
      
      

        initQuickviewAddToCart: function() {
            if (e(".quick-view .add-to-cart-btn").length > 0) {
                e(".quick-view .add-to-cart-btn").click(function() {
                    var n = e(".quick-view select[name=id]").val();
                    if (!n) {
                        n = e(".quick-view input[name=id]").val()
                    }
                    var r = e(".quick-view input[name=quantity]").val();
                    if (!r) {
                        r = 1
                    }
                    var p = e('.quick-view .product-title a').html();
                    var a = e(".quick-view .quickview-featured-image img").attr("src");                 
                    t.doAjaxAddToCart(n, r, a, p);
                    t.closeQuickViewPopup();
                    e('.quick-view').removeClass("open-in");
               		e('.quick-view').removeClass("option-loader");
                })
            }
        },
        updateDropdownCart: function() {
            // Antes de normalizar: leer mínimos/unidades del DOM (Liquid ya resolvió metacampos)
            t._cacheUnidadesDesdeDOM();
            t._cacheMinQtyDesdeDOM();
            Shopify.getCart(function(cart) {
                t._normalizeCartQuantities(cart, function(normalizedCart) {
                    t.doUpdateDropdownCart(normalizedCart);
                });
            })
        },

        _normalizeCartQuantities: function(cart, callback) {
            if (!cart || !cart.items || !cart.items.length) {
                if (callback) callback(cart);
                return;
            }

            var fix = null;
            for (var i = 0; i < cart.items.length; i++) {
                var item = cart.items[i];
                if (t._isPrimeProductHandle(item.handle) && item.quantity > 1) {
                    fix = { id: item.id, qty: 1 };
                    break;
                }
                var minQty = t._getItemMinQty(item);
                if (item.quantity < minQty) {
                    fix = { id: item.id, qty: minQty };
                    break;
                }
            }

            if (!fix) {
                if (callback) callback(cart);
                return;
            }

            Shopify.changeItem(fix.id, fix.qty, function() {
                Shopify.getCart(function(freshCart) {
                    t._normalizeCartQuantities(freshCart, callback);
                });
            });
        },
        doUpdateDropdownCart: function(n) {
            var showPrime = t._shouldShowPrimePricing(n);
            t._cacheUnidadesDesdeDOM();
            t._cacheMinQtyDesdeDOM();
            t._cachePrimeDiscountDesdeDOM();
            var itemTpl = ''
                + '<li class="item{ITEM_PRIME_CLASS}" id="cart-item-{ID}" data-product-handle="{HANDLE}" data-product-type="{PRODUCT_TYPE}" data-unidad="{UNIDAD}" data-min-qty="{MIN_QTY}" data-prime-discount="{PRIME_DISCOUNT}" data-line-price="{LINE_PRICE_RAW}">'
                + '<a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a>'
                + '<div class="product-details">'
                + '<p class="product-name"><a href="{URL}">{PRODUCT_TITLE}</a>{PRIME_BADGE}</p>'
                + '{META}'
                + '<p class="product-line-price{LINE_PRICE_CLASS}">{LINE_PRICE_HTML}</p>'
                + '<div class="product-actions">'
                + '<div class="vf-qty-control" data-item-id="{ID}" data-item-key="{KEY}" data-min-qty="{MIN_QTY}">'
                + '<button type="button" class="vf-qty-control__btn vf-qty-dec" aria-label="Reducir cantidad" {DISABLED_DEC}>&#8722;</button>'
                + '<span class="vf-qty-control__value">{QUANTITY}</span>'
                + '<button type="button" class="vf-qty-control__btn vf-qty-inc" aria-label="Aumentar cantidad" {DISABLED_INC}>+</button>'
                + '</div>'
                + '<button type="button" class="btn-remove" aria-label="Eliminar producto">Eliminar</button>'
                + '</div></div></li>';

            var displayTotals = t._getCartDisplayTotals(n);

            e("#cartCount").text(n.item_count);
            e("#vf-cart-sidebar-count").text("(" + n.item_count + ")");
            e(".ajax-success-modal").find(".ajax_cartCount").text(n.item_count);
            e(".ajax-success-modal").find(".ajax_cartTotal").html(Shopify.formatMoney(displayTotals.total, window.money_format));
            e("#minicart_total span.money").html(Shopify.formatMoney(displayTotals.total, window.money_format));
            e("#vf-cart-subtotal").html(Shopify.formatMoney(displayTotals.subtotal, window.money_format));
            e("#slidedown-cart .mini-products-list").html("");

            if (n.item_count > 0) {
                for (var i = 0; i < n.items.length; i++) {
                    var item = n.items[i];
                    var html = itemTpl;
                    var subtitle = t._getCartItemSubtitle(item);
                    var metaHtml = subtitle
                        ? '<p class="product-meta">' + subtitle + "</p>"
                        : "";
                    var isPrimeSubscription = t._isPrimeProductHandle(item.handle);
                    var itemUnidad = t._getItemUnidad(item);
                    var isPlanOrCuota = t._isPlanOrCuotaItem(item);
                    var isService = !isPrimeSubscription && !isPlanOrCuota;
                    var minQty = t._getItemMinQty(item);
                    if (item.handle) {
                        t._minQtyPorHandle[String(item.handle).toLowerCase()] = minQty;
                    }
                    var hasAppliedDiscount = !isPlanOrCuota && item.original_line_price && item.original_line_price > item.line_price;
                    var hasPrimeDiscount = isService && (t._itemHasPrimeDiscount(item) || !!hasAppliedDiscount);
                    var primeBadge = showPrime && hasPrimeDiscount
                        ? '<span class="vf-cart-prime-badge">PRIME</span>'
                        : "";
                    var itemPrimeClass = showPrime && hasPrimeDiscount ? " item--prime-priced" : "";
                    var linePriceClass = showPrime && hasPrimeDiscount ? " product-line-price--prime" : "";

                    html = html.replace(/\{ID\}/g, item.id);
                    html = html.replace(/\{KEY\}/g, item.key);
                    html = html.replace(/\{URL\}/g, item.url);
                    html = html.replace(/\{TITLE\}/g, item.title);
                    html = html.replace(/\{PRODUCT_TITLE\}/g, item.product_title);
                    html = html.replace(/\{HANDLE\}/g, item.handle || "");
                    html = html.replace(/\{PRODUCT_TYPE\}/g, item.product_type || "");
                    html = html.replace(/\{UNIDAD\}/g, itemUnidad.sing);
                    html = html.replace(/\{QUANTITY\}/g, item.quantity);
                    html = html.replace(/\{IMAGE\}/g, Shopify.resizeImage(item.image, "compact"));
                    html = html.replace(/\{LINE_PRICE_RAW\}/g, item.line_price);
                    html = html.replace(/\{PRIME_DISCOUNT\}/g, t._getItemPrimeDiscount(item));
                    html = html.replace(/\{LINE_PRICE_HTML\}/g, t._buildLinePriceHtml(item, showPrime));
                    html = html.replace(/\{LINE_PRICE_CLASS\}/g, linePriceClass);
                    html = html.replace(/\{ITEM_PRIME_CLASS\}/g, itemPrimeClass);
                    html = html.replace(/\{PRIME_BADGE\}/g, primeBadge);
                    html = html.replace(/\{META\}/g, metaHtml);
                    html = html.replace(/\{MIN_QTY\}/g, minQty);
                    html = html.replace(/\{DISABLED_DEC\}/g, item.quantity <= minQty ? "disabled" : "");
                    html = html.replace(/\{DISABLED_INC\}/g, isPrimeSubscription ? "disabled" : "");
                    e("#slidedown-cart .mini-products-list").append(html);
                }

                if (t.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "#slidedown-cart span.money", "money_format");
                    Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "#minicart_total span.money", "money_format");
                    Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), ".ajax_cartTotal span.money", "money_format");
                }
            }

            t._updatePrimeState(n);
            t.checkItemsInDropdownCart();
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency
        },
        loadQuickViewSlider: function(product, r) {
            var s = Shopify.resizeImage(product.featured_image, "grande");
            r.find(".quickview-featured-image").append('<a href="' + product.url + '"><img src="' + s + '" title="' + product.title + '"/><div style="height: 100%; width: 100%; top:0px; left:-260px; z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
            if (product.images.length > 1) {
                var o = r.find(".more-view-wrapper ul");
                for (i in product.images) {
                    var u = Shopify.resizeImage(product.images[i], "grande");
                    var a = Shopify.resizeImage(product.images[i], "medium");
                    var f = '<li><a href="javascript:void(0)" data-image="' + u + '"><img src="' + a + '"  /></a></li>';
                    o.append(f)
                }
                o.find("a").click(function() {
                    var t = r.find(".quickview-featured-image img");
                    var product = r.find(".quickview-featured-image div");
                    if (t.attr("src") != e(this).attr("data-image")) {
                        t.attr("src", e(this).attr("data-image"));
                        product.show();
                        t.load(function(t) {
                            product.hide();
                            e(this).unbind("load");
                            product.hide()
                        })
                    }
                });
               
                 if (o.hasClass("quickview-more-views-owlslider")) {
                    t.initQuickViewMoreview(o)
                } else {
                    t.initQuickViewMoreview(o)
                }
              
            } else {
             
                r.find(".more-view-wrapper").remove();
               
            } 
        },
         closeEmailModalWindow: function() {
            if (e("#email-modal").length > 0 && e("#email-modal").is(":visible")) {
                e("#email-modal .modal-window").fadeOut(600, function() {
                    e("#email-modal .modal-overlay").fadeOut(600, function() {
                        e("#email-modal").hide();
                        e.cookie("emailSubcribeModal", "closed", {
                            expires: 1,
                            path: "/"
                        })
                    })
                })
            }
        },
        initQuickViewMoreview: function(t) {
            if (t) {
                t.owlCarousel({
                   // loop:false,
                    margin:10,
                    //nav:true,
                    //navContainer: ".quick-view-carousel",
                    //navText: ['<a class="prev"><i class="zmdi zmdi-arrow-left" ></i></a>','<a class="next"><i class="zmdi zmdi-arrow-right" ></i></a>'],
                    dots: true,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:3
                        },
                        1000:{
                            items: 4
                        }
                    }
                });
            }
          
        },
      
     
        convertToSlug: function(e) {
            return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
       createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
            if (product.variants.length > 1) { //multiple variants
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                    quickviewTemplate.find('form.variants > select').append(option);
                }
                new Shopify.OptionSelectors("product-select-" + product.id, {
                    product: product,
                    onVariantSelected: selectCallbackQuickview
                });

                //start of quickview variant;
                var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
                var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
                var options = "";
                for (var i = 0; i < product.options.length; i++) {
                    options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                    options += '<div class="header">' + product.options[i].name + '</div>';
                    var is_color = false;
                    if (/Color|Colour/i.test(product.options[i].name)) {
                        is_color = true;
                    }
                    var optionValues = new Array();
                    for (var j = 0; j < product.variants.length; j++) {
                        var variant = product.variants[j];
                        var value = variant.options[i];
                        var valueHandle = this.convertToSlug(value);
                        var forText = 'swatch-' + i + '-' + valueHandle;
                        if (optionValues.indexOf(value) < 0) {
                            //not yet inserted
                            options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

                            if (is_color) {
                                options += '<div class="tooltip">' + value + '</div>';
                            }
                            options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

                            if (is_color) {
                                options += '<label for="' + forText + '" style="background-color: ' + valueHandle + '; background-image: url(' + filePath + valueHandle + '.png)"><img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
                            } else {
                                options += '<label for="' + forText + '">' + value + '<img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
                            }
                            options += '</div>';
                            if (variant.available) {
                                $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                            }
                            optionValues.push(value);
                        }
                    }
                    options += '</div>';
                }
                quickviewTemplate.find('form.variants > select').after(options);
                quickviewTemplate.find('.swatch :radio').change(function() {
                    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                    var optionValue = $(this).val();
                    $(this)
                        .closest('form')
                        .find('.single-option-selector')
                        .eq(optionIndex)
                        .val(optionValue)
                        .trigger('change');
                });
                if (product.available) {
                    Shopify.optionsMap = {};
                    Shopify.linkOptionSelectors(product);
                }

                //end of quickview variant
            } else { //single variant
                quickviewTemplate.find('form.variants > select').remove();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
              if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                            }
            }
        },
        createQuickViewVariants: function(t, product) {
            if (t.variants.length > 1) {
                for (var r = 0; r < t.variants.length; r++) {
                    var i = t.variants[r];
                    var s = '<option value="' + i.id + '">' + i.title + "</option>";
                    product.find("form.variants > select").append(s)
                }
                new Shopify.OptionSelectors("product-select-" + t.id, { product: t,  onVariantSelected: selectCallbackQuickview  });
               
                if (t.options.length == 1) {
                    e(".selector-wrapper:eq(0)").prepend("<label>" + t.options[0].name + "</label>")
                }
                product.find("form.variants .selector-wrapper label").each(function(n, r) {
                    e(this).html(t.options[n].name)
                })
            } else {
                product.find("form.variants > select").remove();
                var o = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
                product.find("form.variants").append(o)
                 
                 if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                            }
            }
        },      
            closeQuickViewPopup: function() {
            e(".quick-view").fadeOut(500)
        },
       initSidebar: function() {
            //if category page then init sidebar
            if (e(".collection_sidebar").length > 0) {
                t.sidebarParams();              
                t.sidebarMapEvents();               
                t.sidebarInitToggle();
                t.sidebarMapClear();
                t.sidebarMapClearAll();
                t.initSortby();                
                t.sidebarMapPaging();
            }
        },
      
       sidebarMapView: function() {
            e(".view-mode a").click(function(n) {
                if (!e(this).hasClass("active")) {
                    var paging = e(".filter-show  button span").text();
                    if (e(this).hasClass("list")) {
                        Shopify.queryParams.view = "list" + paging;
                    } else {
                        Shopify.queryParams.view = paging;
                    }

                    t.sidebarAjaxClick();
                    e(".view-mode a.active").removeClass("active");
                    e(this).addClass("active");
                }
                n.preventDefault();
            });
        },
             
      sidebarMapShow: function() {
            e(".filter-show a").click(function(n) {
                if (!e(this).parent().hasClass("active")) {
                    var thisPaging = e(this).attr('href');

                    var view = e(".view-mode a.active").attr("href");
                    if (view == "list") {
                        Shopify.queryParams.view = "list" + thisPaging;
                    } else {
                        Shopify.queryParams.view = thisPaging;
                    }

                    t.sidebarAjaxClick();                  
                    e(".filter-show .btn span").text(thisPaging);
                    e(".filter-show li.active").removeClass("active");
                    e(this).parent().addClass("active");
                }
                n.preventDefault();
            });
        },
      
        sidebarMapSorting: function(n) {
            e(".filter-sortby a").click(function(n) {
                if (!e(this).parent().hasClass("active")) {
                    Shopify.queryParams.sort_by = e(this).attr("href");
                    t.sidebarAjaxClick();
                    var sortbyText = e(this).text();                  
                    e(".filter-sortby  button span").text(sortbyText);
                    e(".filter-sortby li.active").removeClass("active");
                    e(this).parent().addClass("active");
                }
                n.preventDefault();
            });
        },
      
       initSortby: function() {
            //sort by filter
            if (Shopify.queryParams.sort_by) {
                var sortby = Shopify.queryParams.sort_by;
                var sortbyText = e(".filter-sortby a[href='" + sortby + "']").text();
                e(".filter-sortby  button span").text(sortbyText);
                e(".filter-sortby li.active").removeClass("active");
                e(".filter-sortby a[href='" + sortby + "']").parent().addClass("active");
            }
        },
        sidebarMapPaging: function() {
            e(".pagination-custom a").click(function(n) {
                var page = e(this).attr("href").match(/page=\d+/g);
                if (page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = t.sidebarCreateUrl();
                        t.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        t.sidebarGetContent(newurl);
                        //go to top
                        e('body,html').animate({
                            scrollTop: 500
                        }, 600);
                    }
                }
                n.preventDefault();
            });
        },
       sidebarMapTagEvents: function() {
          	e('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function(n) {
                var currentTags = [];
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }

                //one selection or multi selection
                if (!window.enable_sidebar_multiple_choice && !e(this).prev().is(":checked")) {
                    //remove other selection first
                    var otherTag = e(this).parents('.sidebar-tag').find("input:checked");
                    if (otherTag.length > 0) {
                        var tagName = otherTag.val();
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                //remove tag
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    }
                }

                var tagName = e(this).prev().val();
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                t.sidebarAjaxClick();
                n.preventDefault();
            });
        },
       
        
      
        sidebarInitToggle: function() {
            if (e(".sidebar-tag").length > 0) {
                e(".sidebar-tag .widget span").click(function() {
                    var $title = e(this).parents('.widget');
                    if ($title.hasClass('click')) {
                        $title.removeClass('click');
                    } else {
                        $title.addClass('click');
                    }

                    e(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
                });
            }
        },
       
       
        sidebarMapClearAll: function() {
            //clear all selection
            e('.refined-widgets a.clear-all').click(function(n) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;
                t.sidebarAjaxClick();
                n.preventDefault();
            });
        },
        sidebarMapClear: function() {
            e(".sidebar-tag").each(function() {
                var sidebarTag = e(this);
                if (sidebarTag.find("input:checked").length > 0) {
                    //has active tag
                    sidebarTag.find(".clear").show().click(function(n) {                     
                        var currentTags = [];
                        if (Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = e(this);
                            var tagName = selectedTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if (currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
						t.sidebarAjaxClick();
                        n.preventDefault();
                    });
                }
            });
        },
        sidebarMapEvents: function() {
            t.sidebarMapTagEvents();
            t.sidebarMapView();     
          	t.sidebarMapShow();
            t.sidebarMapSorting();
        },
         reActivateSidebar: function() {
            e(".sidebar-tag .active").removeClass("active");
            e(".sidebar-tag input:checked").attr("checked", false);

           
//view mode and show filter
            if (Shopify.queryParams.view) {
                $(".view-mode .active").removeClass("active");
                var view = Shopify.queryParams.view;
                if (view.indexOf("list") >= 0) {
                    $(".view-mode .list").addClass("active");
                    //paging
                    view = view.replace("list", "");
                } else {
                    $(".view-mode .grid").addClass("active");
                }
                $(".filter-show > button span").text(view);
                $(".filter-show li.active").removeClass("active");
                $(".filter-show a[href='" + view + "']").parent().addClass("active");
            }
            t.initSortby();
        },
        sidebarMapData: function(data) {
            var currentList = e(".col-main .products-grid-view");
            if (currentList.length == 0) {
                currentList = e(".col-main .product-list-view");
            }
            var productList = e(data).find(".col-main .products-grid-view");
            if (productList.length == 0) {
                productList = e(data).find(".col-main .product-list-view");
            }           
            currentList.replaceWith(productList);
            //convert currency
            if (t.checkNeedToConvertCurrency()) {
                Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '.col-main span.money', 'money_format');
            }

            //replace refined
            e(".refined-widgets").replaceWith(e(data).find(".refined-widgets"));
            
            //replace tags
            e(".sidebar-block").replaceWith(e(data).find(".sidebar-block"));
                   
          //replace paging
            if (e(".padding").length > 0) {
                e(".padding").replaceWith(e(data).find(".padding"));
            } else {
                e(".grid-link__container.col-main").append(e(data).find(".padding"));
            }
          
           if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
        },
        sidebarCreateUrl: function(baseLink) {
            var newQuery = e.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }
            return location.pathname + "?" + newQuery;
        },
        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = t.sidebarCreateUrl(baseLink);
            t.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            t.sidebarGetContent(newurl);
        },
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    t.showLoading();
                },
                success: function(data) {
                    t.sidebarMapData(data);
                    t.sidebarMapTagEvents();
                    t.sidebarInitToggle();
                    t.sidebarMapClear();
                    t.sidebarMapClearAll();
                    t.hideLoading();
                    t.initQuickView();
                    t.initAddToCart();
                    t.initThumbchange();
                    t.initlightSlider()
                    t.initWishlist();
                    t.sidebarMapPaging();
                    t.initInfiniteScrolling();
                },
                error: function(xhr, text) {
                    t.hideLoading();
                    e('.loading-modal').hide();
                    e('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    t.showModal('.ajax-error-modal');
                }
            });
        },
        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
       initInfiniteScrolling: function() {
            e(".infinite-scrolling").length > 0 && e(".infinite-scrolling a").click(function(i) {
                i.preventDefault(), e(this).hasClass("disabled") || t.doInfiniteScrolling()
            })
        },
        doInfiniteScrolling: function() {
            var currentList = $('.col-main .products-grid-view');
            if (!currentList.length) {
                currentList = $('.col-main .product-list-view');
            }
            if (currentList) {
                var showMoreButton = $('.infinite-scrolling a').first();
                $.ajax({
                    type: 'GET',
                    url: showMoreButton.attr("href"),
                    beforeSend: function() {
                        t.showLoading();
                        $('.loading-modal').show();
                    },
                    success: function(data) {
                        t.hideLoading();
                        var products = $(data).find(".col-main .products-grid-view");
                        if (!products.length) {
                            products = $(data).find(".col-main .product-list-view");
                        }
                        if (products.length) {
                            currentList.append(products.children());
                            t.initQuickView();
                            t.initAddToCart();
                          t.initThumbchange();
                            t.initlightSlider();
                            t.initWishlist();
                            //get link of Show more
                            if ($(data).find('.infinite-scrolling').length > 0) {
                                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
                            } else {
                                //no more products
                                showMoreButton.hide();
                                showMoreButton.next().show();
                            }
                          
                          	//currency
                            if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                            }
                          
                            t.initColorSwatchGrid();
                          
                            //product review
                            if ($(".spr-badge").length > 0) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            }
                        }
                    },
                    error: function(xhr, text) {
                        t.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        t.showModal('.ajax-error-modal');
                    },
                    dataType: "html"
                });
            }
        },
      
      convert_currency: function(value) {            
      var newCurrency = Currency.currentCurrency;
      var oldCurrency = shopCurrency;
      if(isNaN(value)){
        value =  0.0;
      }

      var cents = 0.0;
      var oldFormat = Currency.moneyFormats['USD'][ Currency.format] || '';
                                            var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
                                            if (oldFormat.indexOf('amount_no_decimals') !== -1) {
                                              cents = Currency.convert(parseInt(value, 10)*100, oldCurrency, newCurrency);
                                            }
      else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt(value, 10)/10, oldCurrency, newCurrency);
      }
      else { 
        cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
      }
    var my_data =  Currency.formatMoney(cents, newFormat);
      return my_data;


    },

    initPrimeProduct: function() {
      var t = this;

      if (jQuery('.product-servicios-prime').length === 0) return;

      jQuery('.prime-ventajas-toggle').on('click', function() {
        jQuery('.prime-ventajas').toggleClass('open');
      });

      jQuery('#AddToCartPrime').on('click', function(e) {
        e.preventDefault();
        t.mostrarModalPrime();
      });

      jQuery('.prime-modal-close, .btn-cancelar, .prime-modal-overlay').on('click', function() {
        t.cerrarModalPrime();
      });

      jQuery('.btn-prime-seleccionar').on('click', function() {
        var primeHandle = jQuery(this).closest('.prime-opcion').data('prime-handle');
        t.agregarPrimeAlCarrito(primeHandle);
      });

      jQuery('#productSelect').on('change', function() {
        t.actualizarPreciosPrime();
      });

      jQuery('#quantity').on('input change', function() {
        t.actualizarPreciosPrime();
      });

      t.actualizarPreciosPrime();
    },

    mostrarModalPrime: function() {
      jQuery('#primeModal').addClass('active');
      jQuery('body').css('overflow', 'hidden');
    },

    cerrarModalPrime: function() {
      jQuery('#primeModal').removeClass('active');
      jQuery('body').css('overflow', '');
      t._primeModalContext = null;
    },

    agregarPrimeAlCarrito: function(primeHandle) {
      var t = this;
      var serviceVariantId = jQuery('#productSelect').val();
      var quantity = jQuery('#quantity').val() || 1;
      var serviceData = 'quantity=' + quantity + '&id=' + serviceVariantId;
      var planKey = primeHandle.replace('prime-', '');
      var primeDiscount = t._getPrimeDiscountFromForm();

      if (primeDiscount > 0) {
        serviceData += '&properties[_prime_discount]=' + encodeURIComponent(primeDiscount);
      }

      var unidad = t._getUnidadFromForm();
      if (unidad) {
        serviceData += '&properties[_unidad]=' + encodeURIComponent(unidad);
      }
      var minQty = t._getMinQtyFromForm();
      if (minQty > 0) {
        serviceData += '&properties[_min_qty]=' + encodeURIComponent(minQty);
      }

      t.mostrarLoadingPrime();

      if (typeof window.vfAddServiceWithPrimeBundle !== 'function') {
        t.ocultarLoadingPrime();
        t.cerrarModalPrime();
        jQuery('.ajax-error-message').text('No se pudo cargar el flujo PRIME.');
        t.showModal('.ajax-error-modal');
        return;
      }

      window.vfAddServiceWithPrimeBundle(serviceData, planKey)
        .then(function(result) {
          t.ocultarLoadingPrime();
          t.cerrarModalPrime();
          window.vfHandlePrimeBundleResult(result, {
            onSuccess: function() {
              t.showSuccessConPrime(primeHandle);
            }
          });
        })
        .catch(function(error) {
          t.ocultarLoadingPrime();
          t.cerrarModalPrime();
          window.vfHandlePrimeBundleError(error, {
            onError: function(err, message) {
              t.updateDropdownCart();
              if (typeof window.vfShowPrimeSingleSubscriptionNotice === 'function' && message.indexOf('PRIME') !== -1) {
                window.vfShowPrimeSingleSubscriptionNotice(message);
              } else {
                jQuery('.ajax-error-message').text(message);
                t.showModal('.ajax-error-modal');
              }
            }
          });
        });
    },

    agregarProductoPrime: function(primeHandle) {
      var t = this;
      var planKey = primeHandle.replace('prime-', '');

      if (typeof window.vfAddPrimeSubscriptionToCart === 'function') {
        window.vfAddPrimeSubscriptionToCart(planKey)
          .then(function() {
            t.ocultarLoadingPrime();
            t.cerrarModalPrime();
            t.showSuccessConPrime(primeHandle);
          })
          .catch(function(error) {
            t.ocultarLoadingPrime();
            t.cerrarModalPrime();
            t.updateDropdownCart();
            var message = (error && error.description) ? error.description : 'No se pudo añadir la suscripción PRIME.';
            if (typeof window.vfShowPrimeSingleSubscriptionNotice === 'function' && message.indexOf('PRIME') !== -1) {
              window.vfShowPrimeSingleSubscriptionNotice(message);
            } else if (typeof window.vfShowStoreNotice === 'function') {
              window.vfShowStoreNotice({ title: 'No se pudo añadir', message: message, variant: 'error' });
            } else {
              jQuery('.ajax-error-message').text(message);
              t.showModal('.ajax-error-modal');
            }
          });
        return;
      }

      var addWithoutHelper = function() {
        jQuery.ajax({
          type: 'post',
          url: '/cart/add.js',
          data: 'quantity=1&id=' + t.getVariantIdByHandle(primeHandle),
          dataType: 'json',
          success: function() {
            t.ocultarLoadingPrime();
            t.cerrarModalPrime();
            t.showSuccessConPrime(primeHandle);
          },
          error: function(xhr) {
            t.ocultarLoadingPrime();
            t.cerrarModalPrime();
            t.updateDropdownCart();
            var message = 'No se pudo añadir la suscripción PRIME.';
            try {
              message = jQuery.parseJSON(xhr.responseText).description || message;
            } catch (e) {}
            jQuery('.ajax-error-message').text(message);
            t.showModal('.ajax-error-modal');
          }
        });
      };

      if (typeof window.vfEnsureSinglePrimeSubscription === 'function') {
        window.vfEnsureSinglePrimeSubscription()
          .then(addWithoutHelper)
          .catch(function(error) {
            t.ocultarLoadingPrime();
            t.cerrarModalPrime();
            var message = (error && error.description) ? error.description : (window.vfPrimeSingleSubscriptionMessage || 'Solo se permite 1 suscripción PRIME en el carrito.');
            if (typeof window.vfShowPrimeSingleSubscriptionNotice === 'function') {
              window.vfShowPrimeSingleSubscriptionNotice(message);
            } else {
              jQuery('.ajax-error-message').text(message);
              t.showModal('.ajax-error-modal');
            }
          });
        return;
      }

      addWithoutHelper();
    },

    getVariantIdByHandle: function(handle) {
      var variantId = null;

      if (handle === 'prime-mensual') {
        variantId = 0;
      } else if (handle === 'prime-anual') {
        variantId = 0;
      }

      if (!variantId || variantId === 0) {
        var select = document.getElementById('productSelect');
        if (select) {
          var options = select.querySelectorAll('option');
          for (var i = 0; i < options.length; i++) {
            if (options[i].textContent.toLowerCase().indexOf(handle) !== -1) {
              variantId = parseInt(options[i].value);
              break;
            }
          }
        }
      }

      return variantId;
    },

    actualizarPreciosPrime: function() {
      var t = this;
      var descuentoPrime = jQuery('.prime-comparativa').data('descuento') || 0;

      if (descuentoPrime <= 0) return;

      var selectedVariant = t.getSelectedVariant();
      if (!selectedVariant) return;

      var baseCents = selectedVariant.price;
      var primeCents = Math.round(baseCents * (100 - descuentoPrime) / 100);
      var ahorroCents = baseCents - primeCents;

      var precioFormateado = t.formatMoney(baseCents);
      var precioPrimeFormateado = t.formatMoney(primeCents);
      var ahorroFormateado = t.formatMoney(ahorroCents);

      var unidadSing = (window.vfUnidad && window.vfUnidad.sing) || 'hora';
      jQuery('#precio-estandar').html(precioFormateado + ' <span class="tarifa-unidad">/' + unidadSing + '</span>');
      jQuery('#precio-prime').html(precioPrimeFormateado + ' <span class="tarifa-unidad">/' + unidadSing + '</span>');
      jQuery('#prime-ahorro-cantidad').html(ahorroFormateado);
    },

    getSelectedVariant: function() {
      var variantId = jQuery('#productSelect').val();
      if (!variantId) return null;

      variantId = parseInt(variantId);

      
      return { id: variantId, price: 0 };
      
    },

    formatMoney: function(cents) {
      if (window.vfFormatMoneyEuro) return window.vfFormatMoneyEuro(cents);
      var moneyFormat = '';
      return moneyFormat.replace(/\{\{.*\}\}/, (cents / 100).toFixed(2).replace('.', ','));
    },

    mostrarLoadingPrime: function() {
      jQuery('#primeLoadingModal').addClass('active');
    },

    ocultarLoadingPrime: function() {
      jQuery('#primeLoadingModal').removeClass('active');
    },

    showSuccessConPrime: function(primeHandle) {
      var t = this;
      var planKey = (primeHandle || '').replace('prime-', '');
      var serviceName = jQuery('.product-single__title').text();
      var serviceImage = jQuery('#product-featured-image').attr('src');
      var totalCents = typeof window.vfGetPrimeBundlePriceCents === 'function'
        ? window.vfGetPrimeBundlePriceCents(planKey, window._vfLastServiceLineCents || t._lastPrimeServiceLineCents)
        : (window._vfLastServiceLineCents || t._lastPrimeServiceLineCents);

      jQuery('.ajax-success-modal .ajax-product-title').text(serviceName + ' + PRIME');
      jQuery('.ajax-success-modal .ajax-product-image').attr('src', serviceImage);
      if (typeof window.vfSetCartSuccessModalPrice === 'function') {
        window.vfSetCartSuccessModalPrice(totalCents);
      } else {
        jQuery('.ajax-success-modal .ajax_price').text(jQuery('#precio-prime').text());
      }
      jQuery('.ajax-success-modal .added-to-wishlist').hide();
      jQuery('.ajax-success-modal .added-to-cart').show();

      t.updateDropdownCart();
      t.showModal('.ajax-success-modal');
    }

  };

  window.themeShop = t;

})(jQuery);